(function () {
    'use strict';

    angular
        .module('fuel')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('fuelSuppliers', {
                sticky: true,
                url: '/fuel-suppliers',
                views: {
                    'fuelSuppliersView': {
                        templateUrl: 'fuel/views/fuel-suppliers.tpl.html',
                        controller: 'FuelSuppliersCtrl',
                        controllerAs: 'fuelSuppliers'
                    }
                }
            })
            .state('fuelPrices', {
                sticky: true,
                url: '/fuel-prices',
                views: {
                    'fuelPricesView': {
                        templateUrl: 'fuel/views/fuel-prices.tpl.html',
                        controller: 'FuelPricesCtrl',
                        controllerAs: 'fuelPrices'
                    }
                }
            })
            .state('fuelUpliftReport', {
                sticky: true,
                url: '/fuel-uplift-report',
                views: {
                    'fuelUpliftReportView': {
                        templateUrl: 'fuel/views/fuel-uplift-report.tpl.html',
                        controller: 'FuelUpliftReportCtrl',
                        controllerAs: 'fuelUplift'
                    }
                }
            });
    }
}());
